module.exports = __webpack_public_path__ + "img/caixa.742ce2f3.svg";